require('./brokerAlreadyUnsuccessfullyPerformedMiFIDTest.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const { ContentBox } = require('commonsComponents/contentBox');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { MYPROFILE_BROKER_URL } = require('constants/index');

const BrokerAlreadyUnsuccessfullyPerformedMiFIDTest = props => {
    const { onOmmitTest, onGoBackToTest }  = props;

    const title = formatText('broker-convenienceMifidTestAlreadyPerformedTestTitle');

    return (
        <ContentBox title={title} titleSeparator={true}>
            <p className="broker-already-unsuccessfully-performed-mifid-test__info">
                <FormattedText value="broker-convenienceMifidTestAlreadyPerformedTestInfo"/>
            </p>
            <section className="broker-already-unsuccessfully-performed-mifid-test__section">
                <i className="broker-already-unsuccessfully-performed-mifid-test__section-icon icon icon-close"/>
                <h4 className="broker-already-unsuccessfully-performed-mifid-test__section-title">
                    <FormattedText value="broker-convenienceMifidTestAlreadyUnsuccessfullyPerformedTestTitle"/>
                </h4>
                <p className="broker-already-unsuccessfully-performed-mifid-test__section-details">
                    <FormattedText value="broker-convenienceMifidTestAlreadyUnsuccessfullyPerformedTestDetails"/>
                </p>
            </section>
            <section className="broker-already-unsuccessfully-performed-mifid-test__section">
                <FormattedText value="broker-convenienceMifidTestAlreadyUnsuccessfullyPerformedTestOmitTest"/>
                {' '}
                <OKButton onClick={onOmmitTest} modifier="link-complementary">
                    <FormattedText value="broker-convenienceMifidTestAlreadyUnsuccessfullyPerformedTestOmitTestButton" />
                </OKButton>
            </section>
            <footer className="broker-already-unsuccessfully-performed-mifid-test__footer">
                <div className="row">
                    <div className="col-xs-6">
                        <OKLink
                            modifier="inherit-styles"
                            to={MYPROFILE_BROKER_URL}
                        >
                            <FormattedText value="broker-convenienceMifidTestAlreadyUnsuccessfullyPerformedTestCancel"/>
                        </OKLink>
                    </div>
                    <div className="col-xs-6 text-right">
                        <OKButton
                            modifier="secondary"
                            onClick={onGoBackToTest}
                        >
                            <FormattedText value="broker-convenienceMifidTestAlreadyUnsuccessfullyPerformedTestGoBackPerformTest"/>
                        </OKButton>
                    </div>
                </div>
            </footer>
        </ContentBox>
    );
};

BrokerAlreadyUnsuccessfullyPerformedMiFIDTest.propTypes = {
    onOmmitTest: PropTypes.func.isRequired,
    onGoBackToTest: PropTypes.func.isRequired
};

module.exports = BrokerAlreadyUnsuccessfullyPerformedMiFIDTest;
